module.exports = require('@feathersjs/rest-client');
